export default __webpack_public_path__ + "static/media/prehistoric_illustration_.d87c4a1b.png";